import { useState } from "react";
import {
  EvaluatedResults,
  GeneralPermissions,
  IAMUserState,
  LandingPageOptions,
  NavItem,
  SetupListNavInfoByDepartment,
  SetupPermission,
  UserData,
} from "../../../types";

import {
  DEFAULT_IAM_USER_DATA,
  DEFAULT_LANDING_PAGE_OPTIONS,
  DEFAULT_OPTION,
  DEFAULT_USER_DATA,
  DEFAULT_USER_EDIT_PERMISSIONS,
  RESOLVED_INITIAL_LAUNCH_CONTEXT,
  SETUP_PERMISSIONS_NONE,
} from "../../../pages/LandingPage/constants";
import { EffectiveUserContext } from "../launch/resolveLaunchContext";

export const useUserState = () => {
  const [user, setUser] = useState<UserData>(DEFAULT_USER_DATA);
  const [isDevUser, setIsDevUser] = useState(false);

  const [permissions, setPermissions] = useState<{
    userPermission: GeneralPermissions;
    setupPermission: SetupPermission;
  }>({
    userPermission: DEFAULT_USER_EDIT_PERMISSIONS,
    setupPermission: SETUP_PERMISSIONS_NONE,
  });

  const [selected, setSelected] = useState<LandingPageOptions>(
    DEFAULT_LANDING_PAGE_OPTIONS,
  );

  const [defaultStore, setDefaultStore] = useState(DEFAULT_OPTION);

  const [tableTitleInfo, setTableTitleInfo] = useState("");

  const [tableTitleInfoForTab, setTableTitleInfoForTab] = useState("");

  const [iamUserState, setIamUserState] = useState<IAMUserState>(
    DEFAULT_IAM_USER_DATA,
  );

  const [evaluatedResults, setEvaluatedResults] = useState<EvaluatedResults>(
    {},
  );

  const [isFetchingUserData, setIsFetchingUserData] = useState(false);

  const [setupListNavInfoByDepartment, setSetupListNavInfoByDepartment] =
    useState<SetupListNavInfoByDepartment>({});

  const [favorites, setFavorites] = useState<NavItem[]>([]);

  const [initialFavorites, setInitialFavorites] = useState<NavItem[]>([]);
  const [resolvedLaunchContext, setResolvedLaunchContext] =
    useState<EffectiveUserContext>(RESOLVED_INITIAL_LAUNCH_CONTEXT);

  return {
    user,
    setUser,

    isDevUser,
    setIsDevUser,

    permissions,
    setPermissions,

    selected,
    setSelected,

    defaultStore,
    setDefaultStore,

    tableTitleInfo,
    setTableTitleInfo,

    tableTitleInfoForTab,
    setTableTitleInfoForTab,

    iamUserState,
    setIamUserState,

    evaluatedResults,
    setEvaluatedResults,

    isFetchingUserData,
    setIsFetchingUserData,

    setupListNavInfoByDepartment,
    setSetupListNavInfoByDepartment,

    favorites,
    setFavorites,

    initialFavorites,
    setInitialFavorites,

    resolvedLaunchContext,
    setResolvedLaunchContext,
  };
};
